export default class {
	constructor() {
		this.select = '.js-category';
		this.selectHead = '.js-category__head';
		this.selectCont = '.js-category__cont';

		this.responsiveAction();
		this.selectAction();
	}
	responsiveAction() {
		if (this.selectHead) {
			window.addEventListener('resize', () => {
				this.selectAction();
			});
			window.addEventListener('load', () => {
				this.selectAction();
			});
		}
	}
	selectAction() {
		const windowW = parseInt(window.innerWidth);
		if (this.selectHead) {
			if (windowW <= 768) {
				this.clickAction();
			}
		}
	}
	clickAction() {
		const select = document.querySelector(this.select);
		const selectHead = document.querySelector(this.selectHead);
		const selectCont = document.querySelector(this.selectCont);
		if (select) {
			selectHead.addEventListener('click', ()=> {
				select.classList.add('is-active');
			});
			selectCont.addEventListener('click', ()=> {
				select.classList.remove('is-active');
			});
		}
	}
}